<template>
    <div style="position: relative;">
        <form class="login-form">
            <form-input :placeholder="$t('COMMON.email')"
                        :key="'email'"
                        :elementID="'email'"
                        :focus="true"
                        :containerClass="'form-group'"
                        :inputType="'email'"
                        v-model="form.email"
                        @enterPressed="login">
            </form-input>

            <form-input :placeholder="$t('COMMON.password')"
                        :elementID="'password'"
                        :containerClass="'form-group'"
                        :key="'password'"
                        :inputType="'password'"
                        :validator="$v.form.password"
                        v-model="form.password"
                        @enterPressed="login">
            </form-input>

            <div class="clearfix">
                <div class="btn-toolbar d-flex align-content-center float-sm-left m-t-1">
                    <button type="button" class="btn btn-cph-primary"
                            name="login"
                            @click="login" :disabled="$v.form.$invalid">
                        {{$t('AUTH.LOGIN.loginButton')}}
                    </button>
                    <span v-if="errorMessage" class="error-msg">
                        {{errorMessage}}
                    </span>
                </div>
                <div class="float-left float-sm-right  m-t-1">
                    <input id="checkbox-keep" type="checkbox">
                    <label class="keep-signed-label" for="checkbox-keep">
                        {{$t('AUTH.LOGIN.keepMeSignedIn')}}
                    </label>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import FormInput from '../../Shared/UI/Form/FormInput.vue';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: 'Login',
    data() {
        return {
            errorMessage: '',
            form: {
                email: '',
                password: ''
            }
        };
    },
    components: {
        FormInput,
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            back: 'getBack'
        })
    },
    methods: {
        ...mapActions(['loginUser']),
        ...mapMutations(['updateUser']),
        async login() {
            if (this.$v.form.$invalid) {
                this.errorMessage = this.$t('AUTH.LOGIN.incorrectLogin');
                return;
            }
            try {
                await this.loginUser(this.form);
                if (this.back) {
                    this.$router.push(this.back.path);
                } else {
                    this.$router.push('/');
                }
            } catch (err) {
                this.errorMessage = this.$t('AUTH.LOGIN.incorrectLogin');
                throw new Error(err);
            }
        },
        acceptCookie() {
            localStorage.setItem('cookie', true)
            this.$modal.hide('privacy-modal')
        },
    },
    validations: {
        form: {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(4)
            }
        }
    },
    created() {
        if (!localStorage.getItem("cookie")) {
            this.$modal.show('privacy-modal')
        }
    }
};
</script>
